export const buildSingleTransactionPayload = ({
  redemptionMethod,
  uvc,
  fileImage,
  aiReceiptResult,
  voucherMethod,
  discount,
  amountValue,
  voucherId,
  projectId,
  retailerId,
}) => ({
  redemptionMethod,
  uvc: uvc.uvc ?? null,
  fileImage: fileImage ?? null,
  aiReceiptResult,
  voucher: voucherId,
  project: projectId,
  retailer: retailerId,
  ...(voucherMethod === "DYNAMIC" && {
    amount: discount > 0 ? discount : amountValue,
  }),
});
